export const options = [
    {
        label: "Sucia",
        icon: "trashFilled",
        key: "sucia",
    },
    {
        label: "Limpieza",
        icon: "broom",
        key: "limpieza",
    },
    {
        label: "Bloqueo",
        icon: "LockFill",
        key: "bloqueada",
    },
]
